/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useMemo, useState } from 'react';
import {
    Button, Modal, ModalBody, ModalHeader, Tab, Tabs,
} from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

import Pagination from './Pagination';
import RuleAssignment from './RuleAssignment';
import RuleResetWarningModal from './RuleResetWarningModal';
import AddRule from './AddRule';
import '../styles/qualityDashboard.scss';

const PageSize = 12;

const RulesModal = ({
    showAddRuleModal, setShowAddRuleModal, updateColumnConfig, assignedRulesLoading,
    assignRulesLoading, dimensions, filterTypes, uperstRuleLoader, rules, dimension,
    setDimension, ruleName, setRuleName, ruleDescription, setRuleDescription,
    filterExpression, setFilterExpression, filterType, setFilterType, showFields,
    fieldsTitle, dimensionError, ruleNameError, ruleDescriptionError,
    filterExpressionError, filterTypeError, onAddNewRule, onTabOneSave, tableColumns,
    onModalClose, showResetModal, setShowResetModal, setConfirmReset,
    selectedRulesForColumn, setSelectedRulesForColumn, activeAccordionItems,
    validationInput, handleValidationInput, onValidateRule, addNewInput, regExResult,
    isTestRegexLoading, removeInput, currentTab, setCurrentTab,
    isDataLengthCheckModalvisible, setIsDataLengthCheckModalvisible,
    selectedColumn, setSelectedColumn, selectedColumnId, setSelectedColumnId,
    selectedRuleId, setSelectedRuleId,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [dropdownMode, setDropdownMode] = useState('portal');

    const addRuleProps = {
        activeAccordionItems,
        fieldsTitle,
        onAddNewRule,
        rules,
        tableColumns,
        showFields,
        ruleName,
        setRuleName,
        ruleNameError,
        ruleDescription,
        setRuleDescription,
        ruleDescriptionError,
        dimension,
        setDimension,
        dimensionError,
        dimensions,
        filterType,
        setFilterType,
        filterTypeError,
        filterTypes,
        filterExpression,
        setFilterExpression,
        filterExpressionError,
        validationInput,
        onValidateRule,
        isTestRegexLoading,
        handleValidationInput,
        addNewInput,
        regExResult,
        removeInput,
        setShowAddRuleModal,
        onTabOneSave,
        uperstRuleLoader,
    };
    /** Memoised result for assigned rules data based on page size and page number */
    const currentPageAssignedRulesData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return selectedRulesForColumn && selectedRulesForColumn.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, selectedRulesForColumn]);

    /** Add selected rules to specific column */
    const onSelect = (column, selectedRules) => {
        setSelectedRulesForColumn(prevState => {
            let temp = [...prevState];
            temp = temp.map(item => {
                if (item.columnId === column) {
                    return {
                        ...item,
                        ruleIds: selectedRules,
                    };
                }
                return item;
            });
            return temp;
        });
    };

    const onSelectRuleForAssignment = (columnId, columnName, ruleId, name) => {
        const columnResult = (selectedRulesForColumn).find(item => item.columnId === columnId);
        const ruleResult = columnResult && columnResult.ruleIds.find(r => r === ruleId);
        setSelectedColumnId(columnId);
        setSelectedColumn(columnName);
        setSelectedRuleId(ruleId);
        if (ruleResult === undefined && name === 'data_length_check') {
            setDropdownMode('default');
            setIsDataLengthCheckModalvisible(true);
        }
        if (ruleResult) {
            setSelectedRulesForColumn(prevState => {
                const temp = [...prevState];
                for (let index = 0; index < temp.length; index++) {
                    if (temp[index].columnId === columnId) {
                        delete temp[index].ruleArgs;
                    }
                }
                return temp;
            });

            setIsDataLengthCheckModalvisible(false);
        }
    };

    const onAddDataLengthCheckDetails = input => {
        setDropdownMode('portal');
        let temp = [...selectedRulesForColumn];
        temp = temp.map(item => {
            if (item.columnId === input.columnId) {
                return {
                    ...item,
                    ruleArgs: [{
                        ruleId: input.ruleId,
                        operator: input.operator,
                        val1: parseInt(input.value1, 10),
                        val2: input.value2 ? parseInt(input.value2, 10) : null,
                        cond: input.operator === 'between' ? 'and' : null,
                    }],
                };
            }
            return item;
        });
        setSelectedRulesForColumn(temp);
        setIsDataLengthCheckModalvisible(false);
    };

    const onCancelDataLengthCheckDetails = input => {
        setSelectedRulesForColumn(prevState => {
            const temp = [...prevState];
            for (let index = 0; index < temp.length; index++) {
                if (temp[index].columnId === input.columnId) {
                    temp[index].ruleIds = temp[index].ruleIds.filter(id => id !== input.ruleId);
                }
            }
            return temp;
        });
    };
    // save action for Assign Rule tab
    const onTabTwoSave = () => {
        const resultedArray = selectedRulesForColumn.map(element => {
            if (element.ruleArgs) {
                return {
                    columnId: element.columnId,
                    ruleIds: element.ruleIds,
                    ruleArgs: element.ruleArgs.map(config => ({
                        ruleId: config.ruleId,
                        operator: config.operator,
                        val1: config.val1,
                        val2: config.val2,
                        cond: config.cond,
                    })),
                };
            }
            return { columnId: element.columnId, ruleIds: element.ruleIds };
        });
        updateColumnConfig(resultedArray);
    };

    return (
        <>
            {(showResetModal && currentTab === 'ASSIGN RULES') && (
                <RuleResetWarningModal
                    showResetModal={showResetModal}
                    setShowResetModal={setShowResetModal}
                    setConfirmReset={setConfirmReset}
                />
            )}
            <Modal
                className="form-modal"
                visible={showAddRuleModal}
                onCancel={onModalClose}
                style={{
                    minWidth: '1000px', marginLeft: '-12rem', maxHeight: '1000px',
                }}
                backdropClosable={false}
            >
                <ModalHeader>
                    <div className="a-modal-example-header">
                        <div className="modal-title-left">
                            <div className="modal-title">DATA QUALITY RULE ADMIN</div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ paddingTop: 0 }}>
                    <div className="true-comply-add-rules-modal">
                        <Tabs
                            defaultValue="2"
                            size="md"
                            className="a-tab-item-padding-10"
                            onChange={e => {
                                setCurrentTab(e.target.innerText);
                            }}
                        >
                            <Tab value="1" label="MANAGE RULES">
                                {AddRule(addRuleProps)}
                            </Tab>
                            <Tab value="2" label="ASSIGN RULES">
                                <div style={{ paddingRight: '1rem' }} className="true-comply-data-quality-modal-card">
                                    <Row>
                                        <Col md={2}>
                                            <h5 style={{ marginLeft: '0.5rem', marginTop: '32px' }}>
                                                Columns
                                            </h5>
                                        </Col>
                                        <Col>
                                            {/* <div className="a-loading a-primstyle={{ height: '1.5rem', width: '1.5rem/> */}
                                        </Col>
                                    </Row>
                                    {assignedRulesLoading ? (
                                        <>
                                            <div className="a-loading a-primary" style={{ marginLeft: '45%' }} />
                                            <div className="a-mt-10 a-h6 a-apply-theme-font-default-white" style={{ marginLeft: '45%' }}>Loading . . .</div>
                                        </>
                                    )
                                        : (
                                            <>
                                                <RuleAssignment
                                                    currentPageAssignedRulesData={currentPageAssignedRulesData}
                                                    isDataLengthCheckModalvisible={isDataLengthCheckModalvisible}
                                                    rules={rules}
                                                    onSelect={onSelect}
                                                    onSelectRuleForAssignment={onSelectRuleForAssignment}
                                                    selectedColumn={selectedColumn}
                                                    selectedColumnId={selectedColumnId}
                                                    selectedRuleId={selectedRuleId}
                                                    onAddDataLengthCheckDetails={onAddDataLengthCheckDetails}
                                                    onCancelDataLengthCheckDetails={onCancelDataLengthCheckDetails}
                                                    dropdownMode={dropdownMode}
                                                    setIsDataLengthCheckModalvisible={setIsDataLengthCheckModalvisible}
                                                />
                                                <Pagination
                                                    className="pagination-bar"
                                                    currentPage={currentPage}
                                                    totalCount={selectedRulesForColumn && selectedRulesForColumn.length}
                                                    pageSize={PageSize}
                                                    onPageChange={page => setCurrentPage(page)}
                                                />
                                            </>
                                        )}
                                </div>
                                <div className="button-comp">
                                    <Button kind="secondary" gray onClick={() => setShowAddRuleModal(false)} size="lg"> CANCEL </Button>
                                    <Button kind="primary" size="lg" onClick={onTabTwoSave} isLoading={assignRulesLoading}> SAVE </Button>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default RulesModal;
